import React, { Component } from "react";

import { makeStyles } from "@material-ui/styles";

import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import store from "../../store";
import { fetchPartidas, reiniciarPartidas } from "../actions/partidas";

import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Icon from "@material-ui/core/Icon";
import DeleteIcon from "@material-ui/icons/Delete";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

import { relative } from "path";

import XLSX from "xlsx";

const styles = {
  paper: {
    position: "absolute",
    width: "800px",
    height: "500px",
    marginLeft: "20%",
    marginTop: "10%",
    outline: "none"
  }
};

class Partidas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [{}],
      currentProduct: { tipo: "marco" },
      selectedRows: 0
    };
  }
  componentDidMount() {
    store.dispatch(fetchPartidas()).then(() => this.fillPartidasList());
  }

  exportFile = () => {
    /* convert state to workbook */
    let cols = this.state.rowData.map((info, i) => {
      return [info.fecha, info.cantidad];
    });
    let hcols = ["Fecha", "cantidad"];
    const exp = [[...hcols], ...cols];
    const ws = XLSX.utils.aoa_to_sheet(exp);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "partidasBayerVR.xlsx");
  };

  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  fillPartidasList() {
    this.setState({ rowData: store.getState().partidasReducer.partidas });
  }

  handleDelete = () => {
    this.setState({ deleteDialog: true });
  };

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onRowSelected = event => {
    console.log(event);
    if (event.node.selected) this.setState({ currentProduct: event.data });
  };

  onSelectionChanged = event => {
    console.log(event.api.getSelectedNodes().length);

    this.setState({ selectedRows: event.api.getSelectedNodes().length });
  };

  handleEdit = () => {
    this.setState({ addOpen: true });
  };

  Transition = props => {
    return <Slide direction="up" {...props} />;
  };
  handleClose = () => {
    this.setState({ deleteDialog: false });
  };

  reiniciarPartidas = () => {
    store.dispatch(reiniciarPartidas()).then(() => {
      this.fillPartidasList();
      this.setState({ deleteDialog: false });
    });
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <Button
            label="Submit"
            variant="contained"
            color="primary"
            onClick={this.handleDelete}
            style={{
              height: "50px",
              width: "15%",
              margin: "20px",
              fontSize: "0.8em",
              alignContent: "center"
            }}
          >
            Reiniciar Partidas
          </Button>
          <Button
            label="Submit"
            variant="contained"
            color="primary"
            onClick={this.exportFile}
            style={{
              height: "50px",
              width: "15%",
              margin: "20px",
              fontSize: "0.8em",
              alignContent: "center"
            }}
          >
            Exportar a Excel
          </Button>
        </div>
        <div className="ag-theme-balham productos-table">
          <AgGridReact
            enableSorting={true}
            enableFilter={true}
            enableColResize={true}
            rowData={this.state.rowData}
            onGridReady={this.onGridReady.bind(this)}
            rowSelection="single"
            onRowSelected={this.onRowSelected}
            onSelectionChanged={this.onSelectionChanged}
          >
            <AgGridColumn
              headerName="#"
              width={40}
              checkboxSelection
              suppressSorting
              suppressMenu
              suppressFilter
              pinned
            />
            <AgGridColumn headerName="Fecha" field="fecha" width={120} />
            <AgGridColumn headerName="Cantidad" field="cantidad" width={100} />
          </AgGridReact>
        </div>
        <Dialog
          open={this.state.deleteDialog}
          TransitionComponent={this.Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {"SEGURO DESEA REINICIAR?"}
          </DialogTitle>

          <DialogActions>
            <Button onClick={this.reiniciarPartidas} color="primary">
              CONFIRMAR
            </Button>
            <Button onClick={this.handleClose} color="primary">
              CANCELAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default Partidas;
